// host has accepted and event is approved by admin
export const isEventUpcoming = (
	event: TGetAllEventCommon | TSingleLiveEventData
) => {
	return (
		(event?.isHostApplicationAccepted || !event?.isHostRequired) &&
		event?.isApproved
	);
};
